import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import { defineMessages, useIntl, FormattedMessage } from 'react-intl';
import { MaintenancePageLayout } from '@commercetools-frontend/application-components';
import ProjectNotFoundSVG from '@commercetools-frontend/assets/images/folder-full-locked.svg';
import { S as ServicePageProjectSwitcher } from './service-page-project-switcher-da22aefc.esm.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/styled/base';
import 'react-router-dom';
import '@commercetools-frontend/application-shell-connectors';
import './index-bdd71e4c.esm.js';
import 'prop-types';
import 'react';
import './index-b6081c20.esm.js';
import '@babel/runtime-corejs3/helpers/slicedToArray';
import '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import '@babel/runtime-corejs3/core-js-stable/object/entries';
import '@babel/runtime-corejs3/core-js-stable/reflect/has';
import '@reduxjs/toolkit';
import 'lodash/mapValues';
import 'omit-empty-es';
import 'redux-thunk';
import '@commercetools-frontend/constants';
import '@commercetools-frontend/notifications';
import '@commercetools-frontend/sdk';
import '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import '@babel/runtime-corejs3/core-js-stable/instance/slice';
import '@babel/runtime-corejs3/core-js-stable/instance/includes';
import '@commercetools-frontend/sentry';
import '@commercetools-frontend/react-notifications';
import '@babel/runtime-corejs3/core-js-stable/instance/starts-with';
import 'redux-logger';
import '@babel/runtime-corejs3/core-js-stable/instance/find';
import '@babel/runtime-corejs3/core-js-stable/array/is-array';
import '@emotion/react';
import '@commercetools-frontend/i18n';
import './oidc-b2520905.esm.js';
import '@babel/runtime-corejs3/core-js-stable/instance/map';
import '@babel/runtime-corejs3/core-js-stable/url';
import '@commercetools-uikit/design-system';
import '@commercetools-uikit/spacings';
import '@commercetools-uikit/flat-button';
import '@commercetools-uikit/icons';
import './location-f21dbc25.esm.js';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import 'memoize-one';
import 'react-select';
import '@commercetools-uikit/accessible-hidden';
import '@commercetools-uikit/select-input';
import '@commercetools-uikit/text';
import '@commercetools-frontend/assets/images/ct-logo.svg';
import '@commercetools-uikit/loading-spinner';
import '@commercetools-frontend/browser-history';
import '@commercetools-frontend/l10n';
import '@babel/runtime-corejs3/core-js-stable/reflect/construct';
import '@babel/runtime-corejs3/helpers/classCallCheck';
import '@babel/runtime-corejs3/helpers/createClass';
import '@babel/runtime-corejs3/helpers/inherits';
import '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import '@babel/runtime-corejs3/helpers/getPrototypeOf';
import '@babel/runtime-corejs3/core-js-stable/object/from-entries';
import '@babel/runtime-corejs3/core-js-stable/instance/flags';
import '@apollo/client/react';
import '@flopflip/combine-adapters';
import '@flopflip/http-adapter';
import '@flopflip/launchdarkly-adapter';
import '@flopflip/react-broadcast';
import '@flopflip/types';
import 'react-redux';
import '@commercetools-uikit/design-system/materials/resets.css';
import '@commercetools-frontend/application-config/ssr';
import '@commercetools-frontend/permissions';
import '@flopflip/memory-adapter';
import '@babel/runtime-corejs3/core-js-stable/json/stringify';
import '@babel/runtime-corejs3/core-js-stable/instance/some';
import '@commercetools-frontend/actions-global';

var messages = defineMessages({
  title: {
    id: 'ProjectNotFound.title',
    defaultMessage: 'We could not find this Project'
  },
  paragraph1: {
    id: 'ProjectNotFound.paragraph1',
    defaultMessage: 'The Project you are looking for either does not exists or you are not authorized to view it. Select another Project to view.'
  },
  paragraph2: {
    id: 'ProjectNotFound.paragraph2',
    defaultMessage: 'Please contact your system administrator if you have any further questions.'
  }
});

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
const ProjectNotFound = () => {
  const intl = useIntl();
  return jsx(MaintenancePageLayout, {
    imageSrc: ProjectNotFoundSVG,
    title: jsx(FormattedMessage, _objectSpread({}, messages.title)),
    label: intl.formatMessage(messages.title),
    paragraph1: jsx(FormattedMessage, _objectSpread({}, messages.paragraph1)),
    paragraph2: jsx(FormattedMessage, _objectSpread({}, messages.paragraph2)),
    bodyContent: jsx(ServicePageProjectSwitcher, {})
  });
};
ProjectNotFound.displayName = 'ProjectNotFound';

export { ProjectNotFound as default };
